import { gql } from "graphql-tag";

export const GET_ANALYTICS_SHARE_LINK = gql`
  query GetAnalyticsShareLink {
    getAnalyticsShareLink {
      resourceType
      resourceSlug
      resourcePayload
      brand {
        brandKey
        brandName
        brandLogoUrl
      }
      expiresAt
      isExpired
    }
  }
`;
